function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isEqual } from 'lodash';
import constants from '../constants/deferredConstants';
import entityActionFactory from './factories/entityActionFactory';
import detailActionFactory from './factories/detailActionFactory';
const entityActions = entityActionFactory('deferred', 'forms');
const detailActions = detailActionFactory('deferred', 'forms');
const noop = () => ({
  type: constants.NOOP
});
const clear = () => ({
  type: constants.CLEAR
});
const serverIndex = (formTypeIdentifiers, path, entityName, indexQuery = {}) => async (dispatch, getState) => {
  var _state$deferred;
  const state = getState();
  const pathState = ((_state$deferred = state.deferred) === null || _state$deferred === void 0 ? void 0 : _state$deferred[path]) || {};
  const {
    indexQuery: lastIndexQuery = {}
  } = pathState;
  const {
    paging = {}
  } = indexQuery;
  let {
    current
  } = paging;
  const {
    size = 20
  } = paging;
  if (current === undefined
  // if filters change, start page at zero.
  || !isEqual(indexQuery.filters, lastIndexQuery.filters)) {
    current = 0;
  }
  // context is  for paging
  // and search.  search is in filters.text.
  const context = {
    paging: {
      current,
      size
    },
    filters: indexQuery.filters,
    // needs an array of indexes
    sort: [{
      index: 'title',
      direction: 'ASC'
    }],
    path
  };
  const newIndexQuery = _objectSpread(_objectSpread({}, indexQuery), context);
  if (isEqual(lastIndexQuery, newIndexQuery)) {
    // we already made this indexQuery, just return
    return dispatch(noop());
  }
  return dispatch(entityActions.serverIndex(_objectSpread(_objectSpread({}, newIndexQuery), {}, {
    filters: _objectSpread(_objectSpread({}, newIndexQuery.filters), {}, {
      formTypeIdentifiers
    })
  })));
};
const serverFilter = (deferredOptionsFormatIn, path, entityName, newFilters) => serverIndex(deferredOptionsFormatIn, path, entityName, newFilters);
const serverShow = (id, query) => async (dispatch, getState) => {
  var _deferred$id;
  const state = getState();
  const {
    deferred
  } = state;
  // add an additional check for loading since multiple formSearchFields can load simultaneously
  if (deferred !== null && deferred !== void 0 && (_deferred$id = deferred[id]) !== null && _deferred$id !== void 0 && _deferred$id.loading) {
    return undefined;
  }
  return dispatch(detailActions.serverShow(id, query));
};
const deferredOptionsActions = _objectSpread(_objectSpread({}, detailActions), {}, {
  serverShow,
  clear,
  serverFilter,
  serverIndex
});
export default deferredOptionsActions;